import React from 'react';
import PropTypes from 'prop-types';
import { memoize } from 'lodash';

import Icon, { GLYPHS } from '../../../../common/icon';
import Spinner from '../../../customers/customersList/spinner';
import SimpleHeader from '../../../../main/headers/simpleHeader';
import { SurvivingCustomer, DuplicateCustomer } from './components';

const isDuplicateSelected = (survivingCustomer, selectedDuplicate) => (
  selectedDuplicate && survivingCustomer.id === selectedDuplicate.survivingCustomer.id
);

const getDuplicatesChangeCallbacks = memoize((selectedDuplicate, onDuplicateChange) => {
  if (!selectedDuplicate) return {};
  return selectedDuplicate.duplicates.reduce(
    (memo, item) => ({
      ...memo,
      [item.id]: () => onDuplicateChange(item),
    }),
    {},
  );
});

const LocateDuplicates = (props) => {
  const duplicatesChangeCallbacks = getDuplicatesChangeCallbacks(props.selectedDuplicate, props.onDuplicateChange);
  return (
    <div>
      <SimpleHeader heading="Duplicate Records" />
      <div className="layout c-wrapper o-page-height">
        <div className="layout__item u-1/2 u-pr+ c-vertical-divider-secondary">
          <div className="c-label c-label--strong u-fontsize-normal">
            Total (<span>{props.duplicates.length})</span>
          </div>
          <div className="c-table-card c-table-new">
            <div className="c-table-card__head">
              <div className="c-table-card__cell u-1/3 u-pb0">
                <div className="c-label">Client</div>
              </div>
              <div className="c-table-card__cell u-1/3 u-pb0">
                <div className="c-label">Email</div>
              </div>
              <div className="c-table-card__cell u-1/3 u-pb0">
                <div className="c-label">Phone</div>
              </div>
            </div>
            {
              props.duplicates.map(item => (
                <SurvivingCustomer
                  key={item.survivingCustomer.id}
                  customer={item.survivingCustomer}
                  onClick={() => props.setSelectedDuplicate(item)}
                  isSelected={isDuplicateSelected(item.survivingCustomer, props.selectedDuplicate)}
                  isMobileCustomer={props.isMobileCustomer(item.survivingCustomer)}
                />
              ))
            }
          </div>
        </div>
        <div className="layout__item u-1/2 u-pl+" display-if={props.selectedDuplicate}>
          <div className="c-label c-label--strong u-fontsize-normal">
            Duplicates
            <span display-if={props.selectedDuplicate.duplicates.length}>
              &nbsp;({props.selectedDuplicate.duplicates.length - 1})
            </span>
          </div>
          <div className="c-table-card c-table-new">
            <div className="c-table-card__head">
              <div className="c-table-card__cell u-1/3 u-pb0">
                <div className="c-label">Client</div>
              </div>
              <div className="c-table-card__cell u-1/3 u-pb0">
                <div className="c-label">Email</div>
              </div>
              <div className="c-table-card__cell u-1/3 u-pb0">
                <div className="c-label">Phone</div>
              </div>
            </div>
            <div className="c-table-card__row" display-if={!props.selectedDuplicate.duplicates.length}>
              <div className="c-table-card__cell u-1/3" />
              <div className="c-table-card__cell u-1/3 u-text-center">
                <Spinner className="u-inline-block" size="small" />
              </div>
              <div className="c-table-card__cell u-1/3" />
            </div>
            {
              props.selectedDuplicate.duplicates
                .filter(item => item.id !== props.selectedDuplicate.survivingCustomer.id)
                .map(item => (
                  <DuplicateCustomer
                    key={item.id}
                    customer={item}
                    disabled={!props.canBeChanged(item)}
                    checked={props.isDuplicateChecked(item)}
                    onChange={duplicatesChangeCallbacks[item.id]}
                    isMobileCustomer={props.isMobileCustomer(item)}
                  />
                ))
            }
          </div>
          <div className="u-fontsize-small" display-if={props.selectedDuplicate.duplicates.length === 1}>
            The customer record does not have duplicates.
            <p>
              <button
                type="button"
                onClick={props.removeFromDuplicateList}
                className="c-link-button u-mt- u-fontsize-small u-type--bold u-type--underline"
              >
                Remove from duplicates list
              </button>
            </p>
          </div>
          <div
            className="u-text-right u-mt+"
            display-if={props.selectedDuplicate.duplicates.length > 1}
          >
            <button
              type="button"
              className="c-btn c-btn--medium"
              onClick={props.selectForMerge}
              disabled={props.checkedDuplicates.length > 3 || props.checkedDuplicates.length < 2}
            >
              <span className="u-align-middle">Merge records</span>
              <Icon glyph={GLYPHS.clone} size="micro" className="u-ml- u-align-middle" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

LocateDuplicates.propTypes = {
  duplicates: PropTypes.array.isRequired,
  selectedDuplicate: PropTypes.object.isRequired,
  onDuplicateChange: PropTypes.func.isRequired,
  selectForMerge: PropTypes.func.isRequired,
  checkedDuplicates: PropTypes.object.isRequired,
  isMobileCustomer: PropTypes.func.isRequired,
  removeFromDuplicateList: PropTypes.func.isRequired,
};

export default LocateDuplicates;
